import parse from 'html-react-parser';
import React from 'react';
import parseLinkOption from '../../utils/LinkUtils';
import {
  attribution,
  attributionLink,
  figureWrapper,
  headingStyle,
  infoContainer,
} from './AdditionalInfo.module.scss';

const AdditionalInfo = ({ heading, text, quoteAttr, link }) => {
  text = text?.data.text;
  link = link?.data.link;
  return (
    <div className={`gridCenterContent ${infoContainer}`}>
      {heading && <h3 className={`${headingStyle}`}>{heading}</h3>}
      <figure className={`${figureWrapper}`}>
        {parse(text, parseLinkOption)}
        {(quoteAttr || link) && (
          <figcaption className={`pSmall ${attribution}`}>
            — {quoteAttr && quoteAttr}
            {quoteAttr && link && ' / '}
            {link && (
              <span className={`inline ${attributionLink}`}>
                {parse(link, parseLinkOption)}
              </span>
            )}
          </figcaption>
        )}
      </figure>
    </div>
  );
};

export default AdditionalInfo;
